export default __webpack_public_path__ + "static/AvenirLTStd-HeavyOblique-95e7ff2fa69a8b119541eb21ae817c83.woff2";